export default "__VITE_ASSET__B_jdMJ6w__"